module.exports = __webpack_public_path__ + "static/product1-ab6b92fc183eecc272bc2c3d0a657c98.png";